import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

export default function ActionsButton({ loading, onClick }) {
  return (
    <Box display="flex" justifyContent="flex-end" alignItems="center">
      <Button
        disabled={loading}
        type="button"
        variant="contained"
        color="primary"
        startIcon={loading && <CircularProgress size={22} />}
        onClick={() => onClick({ draft: false })}
      >
        Start
      </Button>
    </Box>
  );
}
